module.exports = __webpack_public_path__ + "static/media/Slide5.8f954506.JPG";